import { pushTo } from '@app/core/routing';
import { auditReports } from '@mi-front/api-clients';
import { QueryView } from '@mi-front/ui';
import { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { Page } from '../../../../../../components/page/Page';

export function ReportDefinitionDefaultEditorPage() {
  const { formatMessage } = useIntl();
  const params = useParams<{ reportType: string }>();

  const reportType = params.reportType;

  const definitionQuery = auditReports.useGetReportDefinitionByReportType(
    reportType || '',
    undefined, // No blueprintVersion - gets default
    {
      query: {
        refetchOnMount: 'always',
        staleTime: 0,
      },
    },
  );

  useEffect(() => {
    if (definitionQuery.data?.id) {
      // Navigate to the by-id route once we have the definition ID
      pushTo(
        `/audit/config/report-definitions/by-id/${definitionQuery.data.id}`,
        true, // replace = true to maintain same behavior as history.replace
      );
    }
  }, [definitionQuery.data?.id]);

  if (!reportType) {
    return (
      <Page
        htmlTitle={formatMessage({
          id: 'audit.reportDefinitions.reportTemplateTitle',
          defaultMessage: 'Plantilla de Reporte',
        })}
      >
        <Page.Content>
          <div>
            <FormattedMessage
              id="audit.reportDefinitions.reportTypeRequired"
              defaultMessage="El tipo de reporte es requerido"
            />
          </div>
        </Page.Content>
      </Page>
    );
  }

  return (
    <Page
      htmlTitle={formatMessage({
        id: 'audit.reportDefinitions.reportTemplateTitle',
        defaultMessage: 'Plantilla de Reporte',
      })}
    >
      <Page.Content>
        <QueryView query={definitionQuery}>
          {() => {
            // This should not render as we navigate in useEffect
            // But QueryView handles loading/error states
            return <></>;
          }}
        </QueryView>
      </Page.Content>
    </Page>
  );
}
